import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProductZoom from "../../components/ProductZoom";
import { useLazyTransactionDetailsQuery } from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import TopHeader from "../Dashoboard/TopHeader";

const TodayEarningView = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [details, setDetails] = useState({});
  const [transaction, settransaction] = useState({});
  const [booking, setbooking] = useState({});
  const [subscription, setsubscription] = useState({});
  const [recommendation, setrecommendation] = useState({});
  const [wallet, setwallet] = useState({});

  //RTK QUERY
  const [propertyViewApi] = useLazyTransactionDetailsQuery();

  // DETAILS VIEW
  const getView = () => {
    propertyViewApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        settransaction(res?.transaction);
        if (res?.transaction.type == "booking") {
          setbooking(res?.booking);
        }
        if (res?.transaction.type == "mcc") {
          setsubscription(res?.subscription);
        }
        if (res?.transaction.type == "recommendation") {
          setrecommendation(res?.recommendation);
        }
        if (res?.transaction.type == "wallet") {
          setwallet(res?.wallet);
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getView();
    }
  }, []);

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"today-earning-view"} />
      <div className=" block block-rounded ">
        <div className="block-content">
          <div className="user-detail-table">
            <table className="tabledetails table-borderless user-det w-100 mb-5">
              <thead>
                <th colspan="3" className="h8 mb-0 font-weight-light p-3">
                  Details
                </th>
              </thead>
              {booking?.id ? (
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Property ID</td>
                    <td>:</td>
                    <td>{booking?.property?.property_id}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Property Image</td>
                    <td>:</td>
                    <td>
                      {booking?.property ? (
                        <img
                          src={booking?.property?.image}
                          alt="property-img"
                          class="img-fluid"
                          style={{ width: "30%" }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Booking ID</td>
                    <td>:</td>
                    <td>{booking?.booking_id ? booking?.booking_id : "-"}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Service Type</td>
                    <td>:</td>
                    <td>
                      {booking?.service_type ? booking?.service_type : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Amount Paid</td>
                    <td>:</td>
                    <td>
                      ₹ {booking?.amount_paid ? booking?.amount_paid : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Check In</td>
                    <td>:</td>
                    <td>{booking?.check_in ? booking?.check_in : "-"}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Check Out</td>
                    <td>:</td>
                    <td>{booking?.check_out ? booking?.check_out : "-"}</td>
                  </tr>
                </tbody>
              ) : recommendation?.id ? (
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Property ID</td>
                    <td>:</td>
                    <td>{recommendation?.property?.property_id}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Property Image</td>
                    <td>:</td>
                    <td>
                      {recommendation?.property ? (
                        <img
                          src={recommendation?.property?.image}
                          alt="property-img"
                          class="img-fluid"
                          style={{ width: "30%" }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Owner ID</td>
                    <td>:</td>
                    <td>
                      {transaction?.owner?.owner_id
                        ? transaction?.owner?.owner_id
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Recommendation Name</td>
                    <td>:</td>
                    <td>
                      {recommendation?.recommendation?.name
                        ? recommendation?.recommendation?.name
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Validity</td>
                    <td>:</td>
                    <td>
                      {recommendation?.recommendation?.no_of_days
                        ? recommendation?.recommendation?.no_of_days
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Start Date</td>
                    <td>:</td>
                    <td>
                      {recommendation?.start_date
                        ? moment(recommendation?.start_date).format(
                            "DD-MM-YYYY hh:mm a"
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>End Date</td>
                    <td>:</td>
                    <td>
                      {recommendation?.end_date
                        ? moment(recommendation?.end_date).format(
                            "DD-MM-YYYY hh:mm a"
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Amount Paid</td>
                    <td>:</td>
                    <td>₹{transaction?.transaction_amount}</td>
                  </tr>
                </tbody>
              ) : (
                <tbody>
                  <tr>
                    <td style={{ width: "40%" }}>Property ID</td>
                    <td>:</td>
                    <td>{subscription?.property?.property_id}</td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Property Image</td>
                    <td>:</td>
                    <td>
                      {booking?.property ? (
                        <img
                          src={subscription?.property?.image}
                          alt="property-img"
                          class="img-fluid"
                          style={{ width: "30%" }}
                        />
                      ) : (
                        "-"
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Owner ID</td>
                    <td>:</td>
                    <td>
                      {transaction?.owner?.owner_id
                        ? transaction?.owner?.owner_id
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Subscription Name</td>
                    <td>:</td>
                    <td>
                      {subscription?.subscription?.name
                        ? subscription?.subscription?.name
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Start Date</td>
                    <td>:</td>
                    <td>
                      {subscription?.subscription_start_date
                        ? moment(subscription?.subscription_start_date).format(
                            "DD-MM-YYYY hh:mm a"
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>End Date</td>
                    <td>:</td>
                    <td>
                      {subscription?.subscription_end_date
                        ? moment(subscription?.subscription_end_date).format(
                            "DD-MM-YYYY hh:mm a"
                          )
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <td style={{ width: "40%" }}>Amount</td>
                    <td>:</td>
                    <td>
                      ₹{" "}
                      {transaction?.transaction_amount
                        ? transaction?.transaction_amount
                        : "-"}
                    </td>
                  </tr>
                </tbody>
              )}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TodayEarningView;
